<div class="container">
  <div class="row">
    <div class="col-md-3">
      <app-login-dashboard></app-login-dashboard>
    </div>
    <div class="col-md-9">
      <div id="userProfileContainer" class="container card">
        <h3 [ngClass]="{ 'main-title': isEnglish, 'main-title-ar': isArabic }">
          {{ 'UserProfile.RegistrationTitle' | translate }}
          <span *ngIf="isPerson">
            - {{ 'UserProfile.Person' | translate }}</span
          >
          <span *ngIf="!isPerson">
            - {{ 'UserProfile.Company' | translate }}</span
          >
        </h3>

        <ng-container *ngIf="!registrationCompleted">
          <app-bs-alert
            *ngIf="showError"
            class="has-error"
            [key]="this.errorMessageKey"
            [alert]="{ display: true }"
            [importance]="importance.Danger"
          >
          </app-bs-alert>

          <app-bs-alert
            *ngIf="!isPerson"
            class="has-error"
            [alert]="{
              text: 'UserProfile.CompanyDisclaimer' | translate,
              display: true
            }"
          >
          </app-bs-alert>

          <form [formGroup]="form">
            <div id="profileAccordion">
              <div *ngIf="isPerson" class="card">
                <div
                  class="card-header"
                  id="PersonalInfoHeader"
                  data-toggle="collapse"
                  data-target="#PersonalInfo"
                  aria-expanded="true"
                  aria-controls="PersonalInfo"
                >
                  <h5 class="mb-0">
                    <a class="btn-header-link">
                      {{ 'UserProfile.PersonalInfo' | translate }}
                    </a>
                  </h5>
                </div>

                <div
                  id="PersonalInfo"
                  class="collapse show"
                  aria-labelledby="PersonalInfoHeader"
                  data-parent="#profileAccordion"
                >
                  <div class="card-body">
                    <app-profile-person-info
                      [isVerified]="person?.IsVerified"
                      [lookups]="lookups"
                      [form]="form"
                    >
                    </app-profile-person-info>
                  </div>
                </div>
              </div>

              <div *ngIf="!isPerson" class="card">
                <div
                  class="card-header"
                  id="CompanyInfoHeader"
                  data-toggle="collapse"
                  data-target="#CompanyInfo"
                  aria-expanded="true"
                  aria-controls="CompanyInfo"
                >
                  <h5 class="mb-0">
                    <a class="btn-header-link">
                      {{ 'UserProfile.CompanyInfo' | translate }}
                    </a>
                  </h5>
                </div>

                <div
                  id="CompanyInfo"
                  class="collapse show"
                  aria-labelledby="CompanyInfoHeader"
                  data-parent="#profileAccordion"
                >
                  <div class="card-body">
                    <profile-company-info
                      [lookups]="lookups"
                      [form]="form"
                      (onLicenseIssuerChange)="
                        setAuthorityOwnerValidation($event)
                      "
                    >
                    </profile-company-info>
                  </div>
                </div>
              </div>

              <div *ngIf="!isPerson" class="card">
                <div
                  class="card-header"
                  id="CompanyLocationHeader"
                  data-toggle="collapse"
                  data-target="#CompanyLocation"
                  aria-expanded="false"
                  aria-controls="CompanyLocation"
                >
                  <h5 class="mb-0">
                    <a class="btn-header-link">
                      {{ 'UserProfile.CompanyLocation' | translate }}
                    </a>
                  </h5>
                </div>

                <div
                  id="CompanyLocation"
                  class="collapse"
                  aria-labelledby="CompanyLocationHeader"
                  data-parent="#profileAccordion"
                >
                  <div class="card-body">
                    <profile-company-location [form]="form">
                    </profile-company-location>
                  </div>
                </div>
              </div>

              <div *ngIf="!isPerson" class="card">
                <div
                  class="card-header"
                  id="CompanyOwnersHeader"
                  data-toggle="collapse"
                  data-target="#CompanyOwners"
                  aria-expanded="false"
                  aria-controls="CompanyOwners"
                >
                  <h5 class="mb-0">
                    <a class="btn-header-link">
                      {{ 'UserProfile.CompanyOwners' | translate }}
                    </a>
                  </h5>
                </div>

                <div
                  id="CompanyOwners"
                  class="collapse"
                  aria-labelledby="CompanyOwnersHeader"
                  data-parent="#profileAccordion"
                >
                  <div class="card-body">
                    <profile-company-owners
                      [mainForm]="form"
                      [isRequired]="requireOwners"
                      [owners]="authority?.Owners"
                      [lookups]="lookups"
                      [isPowerUser]="true"
                    >
                    </profile-company-owners>
                  </div>
                </div>
              </div>

              <div class="card">
                <div
                  class="card-header"
                  id="ContactInfoHeader"
                  data-toggle="collapse"
                  data-target="#ContactInfo"
                  aria-expanded="false"
                  aria-controls="ContactInfo"
                >
                  <h5 class="mb-0">
                    <a class="btn-header-link">
                      {{ 'UserProfile.ContactInfo' | translate }}
                    </a>
                  </h5>
                </div>
                <div
                  id="ContactInfo"
                  class="collapse"
                  aria-labelledby="ContactInfoHeader"
                  data-parent="#profileAccordion"
                >
                  <div class="card-body">
                    <app-profile-contact-info
                      [isPerson]="isPerson"
                      [lookups]="lookups"
                      [form]="form"
                    >
                    </app-profile-contact-info>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-right ds-btns pt-1">
              <button
                type="button"
                class="ds-btn ds-btn-primary ds-btn-small"
                (click)="register()"
              >
                {{ 'UserProfile.Register' | translate }}
              </button>
            </div>
          </form>
        </ng-container>

        <ng-container *ngIf="registrationCompleted">
          <div class="card-10 congrats_container text-center">
            <img src="assets/Images//Icons/verified-24px.png" class="pt-1" />
            <h3>
              <b>{{ 'CONGRATS' | translate }}</b>
            </h3>
            <app-bs-alert
              [alert]="{
                text:
                  '\<h5>' +
                  ('UserProfile.SuccessMessage' | translate) +
                  '\<b> ' +
                  accountNo +
                  '\</b>\</h5>',
                display: true
              }"
              [importance]="importance.Success"
            >
            </app-bs-alert>

            <button class="ds-btn ds-btn-primary" (click)="login()">
              {{ 'UserProfile.Login' | translate }}
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
